
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $4b8eb267d691f286$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"1GxVg\",\"EmojiPickerComponent.b964b6fd.js\",\"haemK\",\"mobile-upload.f5ce777a.js\",\"dXN7B\",\"sha256SimpleHasher.34f3fee5.js\",\"8Gekp\",\"sha256SimpleHasher.1fd3f520.js\",\"fhU7k\",\"esm.fe46a0d0.js\",\"hyqsV\",\"esm.e99e8d08.js\",\"tLGOl\",\"simpleHasher.3dafbef7.js\",\"hB1FT\",\"simpleHasher.8531f35d.js\",\"1RolH\",\"EmojiPickerComponent.bf111cfb.js\",\"hllqt\",\"basketball--emoji-activity.e22793e6.js\",\"5t3NJ\",\"basketball.89a04b04.js\",\"8JZKd\",\"activity.7479de1f.js\",\"fCcIi\",\"add--emoji-custom.f4f2fe1f.js\",\"ffEVr\",\"vendors~editor_icon.7a33fabc.js\",\"f2tqy\",\"flag--emoji-flags.888b9c58.js\",\"f1x0y\",\"flag.198afb7e.js\",\"1XElS\",\"takeout-food--emoji-food.2ee64337.js\",\"a5PnA\",\"takeout-food.78d524e5.js\",\"61fF8\",\"clock--emoji-frequent.0a3f8620.js\",\"6wr18\",\"vendors~editor_icon.912c9318.js\",\"3W8o1\",\"tree--emoji-nature.e202a9b4.js\",\"ljaqI\",\"tree.8e118205.js\",\"2TvrU\",\"lightbulb--emoji-objects.38e88071.js\",\"hmR49\",\"emoji--emoji-people.ebf5fbae.js\",\"9yJZ4\",\"heart--emoji-symbols.85816f71.js\",\"h9S5s\",\"vehicle-car--emoji-travel.5dc758c1.js\",\"1cGGc\",\"vehicle-car.01bcac42.js\",\"cyCEv\",\"check-circle--emoji-productivity.af5c1723.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.7d036110.js\",\"4S0zt\",\"EmojiPickerComponent.00cbcbdf.js\"]"));


$parcel$global.rlb("37ZO9")
//# sourceMappingURL=EmojiPickerComponent.runtime.3038f44c.js.map
